/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgChartUseCases = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M10 10v10h2v-5h2v5h2v2H2v-2h2v-7h2v7h2V10zm7-8a5 5 0 1 1 0 10 5 5 0 0 1 0-10zm-1 2.17A3.001 3.001 0 0 0 17 10a3.001 3.001 0 0 0 2.829-2H16zm2 .001V6h1.83A3.009 3.009 0 0 0 18 4.171z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgChartUseCases as ChartUseCases };
